var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / dots-v"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.33398C11.25 4.02434 10.6904 4.58398 10 4.58398C9.30964 4.58398 8.75 4.02434 8.75 3.33398C8.75 2.64363 9.30964 2.08398 10 2.08398C10.6904 2.08398 11.25 2.64363 11.25 3.33398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.0007C11.25 10.691 10.6904 11.2507 10 11.2507C9.30964 11.2507 8.75 10.691 8.75 10.0007C8.75 9.31029 9.30964 8.75065 10 8.75065C10.6904 8.75065 11.25 9.31029 11.25 10.0007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.9173C10.6904 17.9173 11.25 17.3577 11.25 16.6673C11.25 15.977 10.6904 15.4173 10 15.4173C9.30964 15.4173 8.75 15.977 8.75 16.6673C8.75 17.3577 9.30964 17.9173 10 17.9173Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsV);
export default __webpack_public_path__ + "static/media/dots-v.2ea3f2ca.svg";
export { ForwardRef as ReactComponent };